<template>
    <div class="self-stretch flex-col justify-start items-start flex py-3">
        <div class="self-stretch h-6 flex-col justify-start items-start flex">
            <div
                class="self-stretch justify-center items-center gap-4 inline-flex"
            >
                <div
                    class="grow shrink basis-0 text-slate-800 dark:text-slate-100 text-base font-medium font-['Inter'] leading-normal"
                >
                    {{ title }}
                </div>
            </div>
        </div>
        <ul
            ref="listEl"
            class="self-stretch py-4 flex-col justify-start items-start gap-4 flex transition-all ease-in-out duration-300"
            :class="{
                'max-h-[1000px] overflow-auto': seeMore,
                'max-h-48 overflow-hidden': !seeMore,
            }"
        >
            <slot name="options"></slot>
        </ul>
        <button
            v-if="isOverflowing"
            type="button"
            class="flex justify-center items-center text-slate-800 dark:text-slate-100 dark:text-slate-200 text-sm font-medium font-['Inter'] leading-tight"
            @click="() => (seeMore = !seeMore)"
        >
            {{ btnText }}
        </button>
    </div>
    <div
        class="h-px flex-col justify-start items-start flex self-stretch h-px bg-slate-200 dark:bg-slate-700"
    ></div>
</template>

<script setup>
import { computed, ref, onUnmounted, watch } from 'vue';

const seeMore = ref(false);
const isOverflowing = ref(false);
const listEl = ref(null);

const props = defineProps({
    title: {
        type: String,
        default: 'Other',
    },
});

const btnText = computed(() => {
    return seeMore.value ? 'See less' : 'See more';
});

const checkOverflow = () => {
    isOverflowing.value = listEl.value.scrollHeight > listEl.value.clientHeight;
};

watch(
    () => listEl.value,
    () => {
        if (listEl.value) {
            checkOverflow();
            window.addEventListener('resize', checkOverflow);
        }
    }
);

onUnmounted(() => {
    window.removeEventListener('resize', checkOverflow);
});
</script>
